module.exports = __webpack_public_path__ + "static/media/TaskManagerLogo_2c_cmyk-04-01.8b070edc.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/TaskManagerLogo_2c_cmyk-04-01.png
// module id = 838
// module chunks = 0